export function resolveFunction(value) {
    if (typeof value === "function")
        value = value();
    return value;
}
